<div class="lightbox" [class.animate]="animate">
    <div #content class="lb-content" [ngClass]="contentClass">
        <ng-content></ng-content>
    </div>
    <a class="close-lightbox" (click)="close()"><i class="pc-icon-close"></i></a>
</div>